
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    titleName: {
      type: String,
      default: ''
    }
  }
})

